// extracted by mini-css-extract-plugin
module.exports = {"settingsTitle":"settings_settingsTitle__v4DGz","sectionContainer":"settings_sectionContainer__18fr4","addSpecialityContainer":"settings_addSpecialityContainer__3sz5U"};